import { ref } from "vue";
  import * as utils from "@/utils/index";
  export default () => {
    const languageList = ["vi-VN"];
    const pageInfo = {"default":{"title":"","ico":""},"vi-VN":{"title":"","ico":""}};

    const languageTxt = {"vi-VN":{},"default":{}};
  
    const getSystemLanguage =  ()=>{
      let res = navigator.language || navigator.userLanguage || navigator.browerLanguage || navigator.systemLanguage;
      if (res.indexOf("-") > -1) {
        const langArr = res.split("-");
        res = langArr[0] === "zh" ? langArr[1] : langArr[0];
      }
      return res.toLowerCase();
    };
    const checkLanguage =  (lang) =>{
      let res = "";
      if (lang) {
        if (lang.indexOf("-") > -1) {
          for (let i = 0; i < languageList.length; i++) {
            if (languageList[i] === lang) {
              res = languageList[i];
            }
          }
        } else {
          const reg = new RegExp(lang, "g");
          for (let i = 0; i < languageList.length; i++) {
            if (reg.test(languageList[i].toLowerCase())) {
              res = languageList[i];
            }
          }
        }
      }
      return res;
    };
    let curLang = checkLanguage(utils.getUrlParams("appLanguage")) || checkLanguage(utils.getUrlParams("language")) || checkLanguage(getSystemLanguage()) || checkLanguage("vi-VN") || "default";
    const initLang = () => {
      document.body.className += " " + curLang;
      document.getElementsByTagName("html")[0].setAttribute("dir", curLang == "ar-SA" ? "rtl" : "ltr");
  
      if (pageInfo[curLang] && pageInfo[curLang].title && pageInfo[curLang].ico) {
        document.title = pageInfo[curLang].title;
        document.getElementById("icon").setAttribute("href", pageInfo[curLang].ico);
        document.getElementById("shortcut").setAttribute("href", pageInfo[curLang].ico);
      }
    };

    const getLangTxt = (key,msg)=>{
      let info = languageTxt[curLang] || languageTxt.default;
      return info[key] || String(msg);
    }
  
    return { curLang, initLang, getLangTxt, langData:languageTxt[curLang]||{} };
  };
  